import { checkUsernameAvailability } from "./utils";

const USERNAME_REGEX = /^[a-z0-9_]+$/;

export function sanitizeUsernameBase(raw) {
  if (!raw) return "";
  const cleaned = String(raw).toLowerCase().replace(/[^a-z0-9_]/g, "");
  return cleaned.slice(0, 30);
}

export function buildUsernameCandidates({ firstName, lastName, email, displayName }) {
  const candidates = [];
  const first = sanitizeUsernameBase(firstName || "");
  const last = sanitizeUsernameBase(lastName || "");

  if (first && last) {
    candidates.push(`${first}${last}`, `${first}_${last}`, `${first}${last.charAt(0)}`);
  } else if (first) {
    candidates.push(first);
  } else if (last) {
    candidates.push(last);
  }

  if (email) {
    const localPart = String(email).split("@")[0];
    const fromEmail = sanitizeUsernameBase(localPart);
    if (fromEmail.length >= 3) candidates.push(fromEmail);
  }

  if (displayName) {
    const parts = String(displayName).trim().split(/\s+/);
    if (parts.length >= 2) {
      const fn = sanitizeUsernameBase(parts[0]);
      const ln = sanitizeUsernameBase(parts.slice(1).join(""));
      if (fn && ln) candidates.push(`${fn}${ln}`);
    }
    const fromDisplay = sanitizeUsernameBase(displayName.replace(/\s+/g, ""));
    if (fromDisplay.length >= 3) candidates.push(fromDisplay);
  }

  const seen = new Set();
  return candidates.filter((candidate) => {
    if (
      candidate.length < 3 ||
      candidate.length > 30 ||
      !USERNAME_REGEX.test(candidate) ||
      seen.has(candidate)
    ) {
      return false;
    }
    seen.add(candidate);
    return true;
  });
}

export async function suggestAvailableUsername(options) {
  const bases = buildUsernameCandidates(options);

  for (const base of bases) {
    try {
      const result = await checkUsernameAvailability(base);
      if (result.available) return base;
    } catch {
      // try next candidate
    }
  }

  const primary = bases[0];
  if (primary) {
    for (let i = 2; i <= 20; i += 1) {
      const suffix = String(i);
      const candidate = primary.slice(0, 30 - suffix.length) + suffix;
      if (candidate.length < 3 || !USERNAME_REGEX.test(candidate)) continue;
      try {
        const result = await checkUsernameAvailability(candidate);
        if (result.available) return candidate;
      } catch {
        // try next suffix
      }
    }
  }

  return "";
}

export const USERNAME_VALIDATION_REGEX = USERNAME_REGEX;
